import { StateContent as e } from "../../motion/StateContent.js";
import { StatusIcon as t } from "../status-icons/StatusIcon.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import i from "clsx";
import { forwardRef as a } from "react";
//#region src/components/badge/Badge.tsx
var o = {
	neutral: "pf:bg-soft-pearl-200 pf:text-soft-pearl-900",
	info: "pf:bg-blue-100 pf:text-blue-800",
	success: "pf:bg-green-100 pf:text-green-800",
	warning: "pf:bg-amber-100 pf:text-amber-900",
	error: "pf:bg-red-100 pf:text-red-800"
}, s = a(function({ label: a, tone: s = "neutral", size: c = "sm", indicatorConfig: l, className: u, ...d }, f) {
	return /* @__PURE__ */ r("span", {
		...d,
		ref: f,
		className: i("pf:inline-flex pf:box-border pf:items-center pf:gap-sm pf:max-w-full pf:font-body pf:font-medium", o[s], c === "sm" ? "pf:min-h-[20px] pf:px-sm pf:rounded-xs pf:text-label-12" : "pf:min-h-[24px] pf:px-md pf:rounded-sm pf:text-label-13", u),
		children: [
			l?.type === "dot" && /* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				className: "pf:size-[6px] pf:shrink-0 pf:rounded-full pf:bg-current"
			}),
			l?.type === "status" && /* @__PURE__ */ n(t, {
				status: l.status,
				label: a,
				"aria-hidden": "true",
				size: c === "sm" ? 12 : 16,
				width: c === "sm" ? 12 : 14,
				height: c === "sm" ? 12 : 14,
				className: i("pf:shrink-0", s === "info" && l.status === "in-progress" && "pf:[&_[stroke]]:stroke-blue-700 pf:[&_path]:fill-blue-700")
			}),
			/* @__PURE__ */ n("span", {
				className: "pf:min-w-0 pf:wrap-anywhere",
				children: /* @__PURE__ */ n(e, {
					state: a,
					value: !0,
					children: a
				})
			})
		]
	});
});
//#endregion
export { s as Badge };
